import { useMemo, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Popover, Whisper, WhisperInstance } from "rsuite";

import NotificationsMenu from "./NotificationsMenu";
import useUser from "../../../api/api-hooks/auth/useUser";
import { GetTotalNotificationsFromTenant } from "./NotificationUtils";

export default function CloudNotifications() {
  const { user } = useUser();
  const { tenantID }: any = useParams();
  const [open, setOpen] = useState(false);
  const whisperRef = useRef<WhisperInstance>(null);
  const totalNotifications = useMemo(() => {
    return GetTotalNotificationsFromTenant(tenantID, user);
  }, [user?.Notifications?.[tenantID]]);

  return (
    <Link
      // TODO: Update this to future notifications page
      to={`/clouds/${tenantID}/activity`}
      onClick={(e) => e.preventDefault()}
      className="nav-link cursor-pointer pr-0"
    >
      {/* <AppTooltip useTooltip content={"Notifications"}> */}
      <Whisper
        trigger="click"
        onEntering={() => setOpen(true)}
        onExited={() => setOpen(false)}
        ref={whisperRef}
        preventOverflow
        speaker={
          <Popover
            className="sidebar-popover"
            style={{ width: "100%", maxWidth: 370 }}
          >
            <NotificationsMenu open={open} whisperRef={whisperRef} />
          </Popover>
        }
        placement="autoVerticalEnd"
      >
        <span className="avatar avatar-sm rounded text-capitalize text-center link-hovered bg-white text-secondary">
          <i
            className="mdi mdi-bell"
            style={{
              fontSize: "24px",
              position: "relative",
              top: 1,
            }}
          />
          {totalNotifications > 0 && (
            <div className="position-absolute">
              <div
                className="position-absolute bg-primary text-white rounded"
                style={{
                  top: -12,
                  left: totalNotifications > 9 ? 2 : 0,
                  lineHeight: 1.1,
                  fontSize: 10,
                  padding: "0 4px",
                }}
              >
                {totalNotifications > 99 ? "99+" : totalNotifications}
              </div>
            </div>
          )}
        </span>
      </Whisper>
      {/* </AppTooltip> */}
    </Link>
  );
}
